import React from 'react';


class Testimonial extends React.Component {
   render() {


      return (
         <section id="testimonial" className="testimonial">
            <div className="testimonial-decor">
               <div className="testi-circle1"><img src="assets/images/Testimonial2.png" alt="" /></div>
               <div className="testi-circle2"><img src="assets/images/Testimonial1.png" alt="" /></div>
            </div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-10 offset-lg-1">
                     <div className="testimonial-carousel">
                        <div className="testimonial-item">
                           <div className="testimonial-block">
                              <div className="testimonial-avtar">
                                 <img
                                    src="assets/images/logoimage.png"
                                    alt="logo-img"
                                    className="caption-img"
                                 />
                              </div>
                              <div className="testimonial-text">
                              <h3>Η ΕΤΑΙΡΕΙΑ</h3>
                              <br/>
                                 <p>Η QRSTAND είναι μια εταιρεία με καταχωρημένα τα πνευματικά δικαιώματα της και με δυναμική προς το μέλλον. Δημιουργήθηκε με γνώμονα τον άνθρωπο και την οικολογική συνείδηση που μας διέπει. Ακολουθώντας τις ραγδαίες εξελίξεις στο χώρο της τεχνολογίας, η QRSTAND σήμερα, με καινοτόμο πνεύμα και προοπτική, παρέχει αξιόπιστες επιχειρηματικές λύσεις και υπηρεσίες που αυτοματοποιούν και απλοποιούν τη δομή μιας έκθεσης, τόσο στην περιήγησης των επισκεπτών μέσα στον εκθεσιακό χώρο, όσο και στην στόχευση μεγαλύτερων αποτελεσμάτων (100% της δυναμικής) στους εκθέτες που λαμβάνουν μέρος. Στην ευέλικτη παροχή υπηρεσιών συνδράμουν η τεχνογνωσία και η εμπειρία που διαθέτει το καταρτισμένο team της εταιρεία στο πλαίσιο υλοποίησης των αναγκών.</p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      );
   }
}


export default Testimonial;


// WEBPACK FOOTER //
// ./src/components/testimonial.js